"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BaseApi {
    constructor(http) {
        this.http = http;
    }
}
exports.default = BaseApi;
